export const environment = {
  production: false,
  // api:'https://'+ location.hostname +'/api/',
  //api:'http://localhost:3011/api/',
  host:'http://localhost',
  local:"http://localhost:4200/",
  front:"http://localhost:4220/",
  api:'https://immostate.lv/api/'
};